import { Snackbar } from '@mui/material';
import { StyledAlert } from './notification.styles';

const Notification = (props) => {
  const { message, type, onClose } = props;

  return (
    <Snackbar
      open
      autoHideDuration={6000}
      onClose={() => onClose()}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <StyledAlert onClose={onClose} severity={type} variant="filled">
        {message}
      </StyledAlert>
    </Snackbar>
  );
};

export default Notification;
